import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  color: #333333;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8.5px 16px 8.5px 24px;
  border-radius: 8px;
  min-height: 40px;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  margin-top: 8px;
`;

export const HeaderText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #000000;
  text-overflow: ellipsis;
`;

export const Cell: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-overflow: ellipsis;
`;

export const CellSmall: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 50px;
  text-overflow: ellipsis;
`;
export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 100px;
`;
